<template>
  <v-container class="content-box">
    <v-form ref="form" v-model="valid" lazy-validation>
      <div class="admin-user-info pb-16">
        <div class="mt-10 main-title">
          <slot>ユーザー編集</slot>
        </div>
        <v-container class="pa-4 pb-10">
          <v-row class="mt-1">
            <v-col cols="12" sm="8">
              <field-label-normal :requiredMark="true" class="usercode"
                >会員種別</field-label-normal
              >
              <v-radio-group
                v-model="userForm.user_code"
                @change="changeUserType"
                :rules="userCodeRule.concat(usercodeChangeValidatiion)"
                row
              >
                <v-radio
                  v-for="user_code in user_codes"
                  :key="user_code.key"
                  :label="user_code.title"
                  :value="user_code.key"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col cols="12" sm="5">
              <field-label-normal :requiredMark="userForm.user_code != user_tab.ADMIN"
                >支部名</field-label-normal
              >
              <v-select
                :items="branches"
                item-text="name"
                item-value="code"
                v-model="userForm.branch_code"
                :rules="
                  showError.branch_code
                    ? showError.branch_code
                    : userForm.user_code != user_tab.ADMIN
                    ? branchCodeRule
                    : []
                "
                dense
                outlined
                hide-details="auto"
                placeholder="選択してください"
                :disabled="userForm.user_code == user_tab.ADMIN"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row class="mt-3">
            <v-col cols="12" sm="5">
              <field-label-normal :requiredMark="userForm.user_code == user_tab.UNION_MEMBER"
                >所属会社名</field-label-normal
              >
              <v-text-field
                v-model="userForm.company_name"
                :rules="
                  showError.company_name
                    ? showError.company_name
                    : userForm.user_code == user_tab.UNION_MEMBER
                    ? companyNameRule
                    : []
                "
                dense
                outlined
                hide-details="auto"
                :disabled="userForm.user_code != user_tab.UNION_MEMBER"
                @input="showError.company_name = ''"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-3">
            <v-col cols="12" sm="5">
              <field-label-normal>代表者肩書</field-label-normal>
              <v-text-field
                v-model="userForm.representative"
                :rules="
                  showError.representative
                    ? showError.representative
                    : userForm.user_code == user_tab.UNION_MEMBER
                    ? representativeRule
                    : []
                "
                dense
                outlined
                hide-details="auto"
                :disabled="userForm.user_code != user_tab.UNION_MEMBER"
                @input="showError.representative = ''"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-3">
            <v-col cols="12" sm="5">
              <field-label-normal>代表者氏名</field-label-normal>
              <v-text-field
                v-model="userForm.president"
                :rules="
                  showError.president
                    ? showError.president
                    : userForm.user_code == user_tab.UNION_MEMBER
                    ? presidentRule
                    : []
                "
                dense
                outlined
                hide-details="auto"
                :disabled="userForm.user_code != user_tab.UNION_MEMBER"
                @input="showError.president = ''"
              ></v-text-field>
            </v-col>
          </v-row>
          <div class="mt-7 error-message">
            <field-label-normal :requiredMark="true"
              >会員住所</field-label-normal
            >
            <v-form ref="zipcodeForm" v-model="zipcodeValid" lazy-validation>
              <div class="text-sub-title pb-3">自宅住所</div>
              <div class="d-flex mx-n3 my-n1">
                <v-col cols="5" sm="2" class="pr-0 pt-0">
                  <v-text-field
                    type="tel"
                    v-model="userForm.zipCdPart1"
                    dense
                    outlined
                    hide-details="auto"
                    class="zipcode1-text-field"
                    :rules="
                      showError.zipCdPart1
                        ? showError.zipCdPart1
                        : [zipcodeFullValidation]
                    "
                    @blur="validateZipcode"
                    @input="
                      showError.zipCdPart1 = '';
                      validateZipcode;
                    "
                  >
                    <div slot="append-outer">―</div>
                  </v-text-field>
                </v-col>
                <v-col cols="4" sm="2" class="pt-0">
                  <v-text-field
                    type="tel"
                    v-model="userForm.zipCdPart2"
                    dense
                    outlined
                    hide-details="auto"
                    class="zipcode2-text-field"
                    :rules="
                      showError.zipCdPart2
                        ? showError.zipCdPart2
                        : [zipcodeFullValidation]
                    "
                    @blur="validateZipcode"
                    @input="
                      showError.zipCdPart2 = '';
                      validateZipcode;
                    "
                  ></v-text-field>
                </v-col>
              </div>
            </v-form>
          </div>
          <div class="mt-3 error-message">
            <v-row>
              <v-col cols="12" sm="4" class="pt-0">
                <div class="text-sub-title mt-5 pb-2">都道府県</div>
                <v-select
                  :items="prefectures"
                  v-model="prefec"
                  dense
                  outlined
                  hide-details="auto"
                  :rules="
                    showError.prefectures
                      ? showError.prefectures
                      : prefecturesRule
                  "
                  @input="showError.prefectures = ''"
                ></v-select>
              </v-col>
            </v-row>
          </div>
          <div class="mt-4 error-message">
            <v-row>
              <v-col cols="12" sm="8" class="pt-0">
                <div class="text-sub-title mt-5 pb-2">住所</div>
                <v-text-field
                  v-model="address"
                  dense
                  outlined
                  hide-details="auto"
                  :rules="
                    showError.address1 ? showError.address1 : address1Rule
                  "
                  @input="showError.address1 = ''"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <div class="mt-3 error-message">
            <v-row>
              <v-col cols="12" sm="8" class="pt-0">
                <div class="text-sub-title mt-5 pb-2">マンション名</div>
                <v-text-field
                  v-model="userForm.address2"
                  dense
                  outlined
                  hide-details="auto"
                  :rules="
                    showError.address2 ? showError.address2 : address2Rule
                  "
                  @input="showError.address2 = ''"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-row class="mt-3">
            <v-col cols="12" sm="5">
              <field-label-normal>担当者所属部署</field-label-normal>
              <v-text-field
                v-model="userForm.staff_department"
                :rules="
                  showError.staff_department
                    ? showError.staff_department
                    : userForm.user_code == user_tab.UNION_MEMBER
                    ? staffDepartmentRule
                    : []
                "
                dense
                outlined
                hide-details="auto"
                :disabled="userForm.user_code != user_tab.UNION_MEMBER"
                @input="showError.staff_department = ''"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-3">
            <v-col cols="12" sm="5">
              <field-label-normal :requiredMark="true"
                >担当者氏名</field-label-normal
              >
              <v-text-field
                v-model="userForm.staff_name"
                :rules="
                  showError.staff_name ? showError.staff_name : staffNameRule
                "
                dense
                outlined
                hide-details="auto"
                @input="showError.staff_name = ''"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-3">
            <v-col cols="12" sm="5">
              <field-label-normal>電話番号</field-label-normal>
              <v-text-field
                type="tel"
                v-model="userForm.tel"
                :rules="showError.tel ? showError.tel : telRule"
                dense
                outlined
                hide-details="auto"
                @input="showError.tel = ''"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-3">
            <v-col cols="12" sm="5">
              <field-label-normal :requiredMark="true" class="label-style"
                >メールアドレス</field-label-normal
              >
              <v-text-field
                v-model="userForm.email"
                :rules="showError.email ? showError.email : emailRules"
                dense
                outlined
                hide-details="auto"
                @input="onEmailInput"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-3">
            <v-col cols="12" sm="5">
              <field-label-normal class="label-style"
                >ログインID</field-label-normal
              >
              <v-text-field
                v-model="userForm.login"
                :rules="
                  showError.login
                    ? showError.login
                    : loginRule.concat(loginExist)
                "
                dense
                outlined
                hide-details="auto"
                @input="showError.login = ''"
                @blur="checkLoginid"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-3">
            <v-col cols="12" sm="5">
              <field-label-normal class="label-style"
                >ログインパスワード</field-label-normal
              >
              <v-text-field
                v-model="userForm.password"
                :rules="showError.password ? showError.password : passwordRules"
                dense
                outlined
                hide-details="auto"
                class="input-login"
                :type="showPassword1 ? 'text' : 'password'"
                :append-icon="showPassword1 ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="showPassword1 = !showPassword1"
                @input="showError.password = ''"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-3">
            <v-col cols="12" sm="5">
              <field-label-normal class="label-style"
                >ログインパスワード（確認）</field-label-normal
              >
              <v-text-field
                v-model="userForm.passwordConfirm"
                :rules="
                  showError.passwordConfirm
                    ? showError.passwordConfirm
                    : passwordRules.concat(passwordConfirmationMatch)
                "
                dense
                outlined
                class="input-login"
                hide-details="auto"
                :type="showPassword2 ? 'text' : 'password'"
                :append-icon="showPassword2 ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="showPassword2 = !showPassword2"
                @input="showError.passwordConfirm = ''"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <div class="mt-12">
            <v-row class="btn-area">
              <v-col cols="12" sm="8">
                <v-btn
                  color="primary"
                  large
                  class="btn-margin btn-text"
                  height="40"
                  width="200"
                  @click="cancel"
                >
                  キャンセル
                </v-btn>
                <v-btn
                  color="secondary"
                  large
                  class="btn-margin btn-text"
                  height="40"
                  width="200"
                  @click="editUser"
                >
                  更新
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </div>
      <confirm-dialog
        icon="mdi-alert"
        iconColor="#E8A43E"
        text="会員種別を管理者以外に変更するとスーパーユーザー領域にログインできなくなります。変更してよろしいでしょうか？"
        confirmText="はい"
        cancelText="キャンセル"
        :show="userCodeChangeShow"
        @yes="setUnionData"
        @cancel="
          userForm.user_code = 3;
          userCodeChangeShow = false;
        "
      ></confirm-dialog>
      <confirm-dialog
        icon="mdi-alert"
        iconColor="#E8A43E"
        text="削除してよろしいでしょうか？"
        confirmText="はい"
        cancelText="キャンセル"
        :show="confirmDeleteShow"
        @yes="confirmDelete"
        @cancel="confirmDeleteShow = false"
      ></confirm-dialog>
    </v-form>
    <!-- <v-row class="punks-area mb-13">
      <span class="punks-textpointer" @click="rowClick">ユーザー一覧</span>
      <span class="ml-1 mt-n2"
        ><svg-icon
          class="arrow-icon"
          iconClass="Icon ionic-ios-user-arrow-forward"
      /></span>
      <span class="punks-text ml-1">ユーザー編集</span>
    </v-row> -->
  </v-container>
</template>
<script>
import FieldLabelNormal from "@/components/FormElements/FieldLabelNormal";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";
import validations from "@/utils/common-validation";
import { editUser, showuserdata, deleteUsers } from "@/api/user";
import { USERCODE } from "@/utils/mst-user";
import { getBranch, logout, checkValidLogin } from "@/api/common";
import { PREFS } from "@/utils/mst-prefectures";
import { Core as YubinBangoCore } from "yubinbango-core";
import { USERTAB } from "@/utils/mst-user";
import { ADMINCOUNT } from "@/utils/mst-user";

export default {
  name: "UserEdit",
  components: {
    FieldLabelNormal,
    ConfirmDialog,
  },
  computed: {
    passwordConfirmationMatch() {
      return (
        !this.userForm.password ||
        !this.userForm.passwordConfirm ||
        this.userForm.password === this.userForm.passwordConfirm ||
        "入力されたパスワードが一致しません。"
      );
    },
    zipcodeFullValidation() {
      return validations.zipcodePart1AndPart2(
        this.userForm.zipCdPart1,
        this.userForm.zipCdPart2
      );
    },
    usercodeChangeValidatiion() {
      return (
        this.userForm.id !== this.login_user.id ||
        this.userForm.user_code === this.user_tab.ADMIN ||
        this.adminCount > this.admin_count ||
        "管理者は少なくとも１ユーザー必要な為、この変更は行えません。"
      );
    },
  },
  data: () => ({
    //パスワード非表示
    userCodeChangeShow: false,
    confirmDeleteShow: false,
    showPassword1: false,
    showPassword2: false,
    zipcodeValid: true,
    valid: true,
    user_codes: USERCODE,
    // Form Data
    userForm: [],
    professionals: [],
    prefectures: PREFS,
    branches: [],
    showError: [],
    oldEmail: null,
    closeEv: "",
    adminCount: "",
    login_user: "",
    prefec: null,
    address: null,
    prevZipcode: null,
    user_tab: USERTAB,
    admin_count: ADMINCOUNT,
    // 会員種別
    userCodeRule: [(v) => validations.required(v)],
    // 支部名
    branchCodeRule: [(v) => validations.requiredSelect(v)],
    // 所属会社名
    companyNameRule: [
      (v) => validations.required(v),
      (v) => validations.fullWidthAndHalfAlphabetAndSpecialSymbols(v),
      (v) => validations.maxLength(v, 50),
    ],
    // 代表者肩書
    representativeRule: [
      (v) => validations.maxLength(v, 50),
      (v) => validations.fullWidthAndHalfAlphabetAndSpecialSymbols(v),
    ],
    // 代表者氏名
    presidentRule: [
      (v) => validations.maxLength(v, 50),
      (v) => validations.fullWidthAndHalfAlphabetAndSpecialSymbols(v),
    ],
    // 会員住所(都道府県)
    prefecturesRule: [(v) => validations.required(v)],
    // 会員住所(住所/マンション名)
    address1Rule: [
      (v) => validations.required(v),
      (v) => validations.maxLength(v, 50),
      (v) => validations.FullWidthHalfWidthAlphabetNumberAndHalfWidthSpace(v),
    ],
    address2Rule: [
      (v) => validations.maxLength(v, 50),
      (v) => validations.FullWidthHalfWidthAlphabetNumberAndHalfWidthSpace(v),
    ],
    // 担当者所属部署
    staffDepartmentRule: [
      (v) => validations.maxLength(v, 50),
      (v) => validations.fullWidthAndHalfAlphabetAndSpecialSymbols(v),
    ],
    // 担当者氏名
    staffNameRule: [
      (v) => validations.required(v),
      (v) => validations.maxLength(v, 50),
      (v) => validations.fullWidthAndHalfAlphabetAndSpecialSymbols(v),
    ],
    // 電話番号
    telRule: [(v) => validations.tel(v)],
    // ログインID
    loginRule: [
      (v) => validations.required(v),
      (v) => validations.maxLength(v, 16),
      (v) => validations.minLength(v, 4),
      (v) => validations.Login(v),
    ],
    // メールアドレス
    emailRules: [
      (v) => validations.required(v),
      (v) => validations.maxLength(v, 200),
      (v) => validations.email(v),
    ],
    // パスワード
    passwordRules: [(v) => validations.password(v)],
    loginExist: true,
  }),
  created: async function () {
    await this.refresh();
  },
  methods: {
    onEmailInput() {
      // メール存在エラーを消す
      this.showError.email = "";
    },
    async refresh() {
      this.login_user = JSON.parse(localStorage.getItem("adminUserInfo"));
      if (this.login_user) {
        let param = {};
        await getBranch(param).then((response) => {
          this.branches = response.data;
        });
        this.userForm.id = this.$route.params.id;
        let params = {
          id: this.userForm.id,
        };

        await showuserdata(params).then((response) => {
          this.adminCount = response.adminCount;
          this.userForm = response.data;
          this.userForm.zipCdPart1 = this.userForm.zipcode.substring(0, 3);
          this.userForm.zipCdPart2 = this.userForm.zipcode.substring(3, 7);
          this.prefec = this.userForm.prefectures;
          this.address = this.userForm.address1;
          this.userForm.password = "";
          this.oldEmail = this.userForm.email;
          this.userForm.old_branch = this.userForm.branch_code;
          this.userForm.old_company_name = this.userForm.company_name;
          this.userForm.old_representative = this.userForm.representative;
          this.userForm.old_president = this.userForm.president;
          this.userForm.old_staff_department = this.userForm.staff_department;
        });
      }
    },
    async editUser() {
      await this.$refs.form.validate();
      if (!this.valid) {
        let domRect = document.querySelector('.error--text').parentNode.getBoundingClientRect();
        window.scrollTo(
          domRect.left + document.documentElement.scrollLeft,
          domRect.top + document.documentElement.scrollTop
        );
        return;
      }
      this.userForm.prefectures = this.prefec;
      this.userForm.address1 = this.address;
      this.userForm.loginid = this.login_user.id;
      await editUser(this.userForm)
        .then((response) => {
          if (response.message == "invalidInput") {
            this.showError = response.error;
            let domRect = document.querySelector('.error--text').parentNode.getBoundingClientRect();
            window.scrollTo(
              domRect.left + document.documentElement.scrollLeft,
              domRect.top + document.documentElement.scrollTop
            );
          } else {
            this.showError = [];
            this.$store.commit("SAVE_DIALOG", {
              text: "保存しました",
              icon: "mdi-checkbox-marked-circle-outline",
            });
            if (
              response.data.id == this.login_user.id &&
              response.data.user_code != this.user_tab.ADMIN
            ) {
              this.logout;
            }
            this.$router.push("/admin/users");
          }
        })
        .catch(() => { });
      this.showuserdata;
    },
    logout() {
      var params = {
        login: this.login_user.login,
      };
      logout(params).then(() => {
        this.$store.commit("SET_USERINFO", {});
        localStorage.setItem("adminUserInfo", null);
        this.$router.push({
          name: "AdminLogin", // 管理者ログイン画面に遷移
        });
      });
    },
    deleteUser() {
      this.confirmDeleteShow = true;
    },
    async confirmDelete() {
      this.$store.commit("SET_LOADING", true);
      const ids = [];
      ids.push(this.userForm.id);
      let params = {
        ids: ids,
      };
      if (this.userForm.id == this.login_user.id) {
        this.closeEv = this.logout;
      } else {
        this.closeEv = this.$router.push("/admin/users");
      }
      // 削除リクエスト
      await deleteUsers(params).then(() => {
        this.confirmDeleteShow = false;
      });
      this.$store.commit("SAVE_DIALOG", {
        text: "削除しました",
        icon: "mdi-checkbox-marked-circle-outline",
        closeEvent: () => {
          this.closeEv;
        },
      });
    },
    changeUserType() {
      if (this.login_user.id === this.userForm.id) {
        if (this.userForm.user_code != this.user_tab.ADMIN) {
          this.userCodeChangeShow = true;
        } else {
          this.setUnionData();
        }
      } else {
        this.setUnionData();
      }
    },
    setUnionData() {
      this.userCodeChangeShow = false;
      if (this.userForm.user_code == this.user_tab.UNION_MEMBER) {
        this.userForm.branch_code = this.userForm.old_branch;
        this.userForm.company_name = this.userForm.old_company_name;
        this.userForm.representative = this.userForm.old_representative;
        this.userForm.president = this.userForm.old_president;
        this.userForm.staff_department = this.userForm.old_staff_department;
      } else {
        this.userForm.company_name = "";
        this.userForm.representative = "";
        this.userForm.president = "";
        this.userForm.staff_department = "";
        if (this.userForm.user_code == this.user_tab.SALE_MEMBER) {
          this.userForm.branch_code = this.userForm.old_branch;
        } else {
          this.userForm.branch_code = "";
        }
      }
    },
    checkLoginid() {
      if (this.userForm.login) {
        var isFormatValid = true;
        this.loginRule.forEach((validate) => {
          if (validate(this.userForm.login) != true) {
            isFormatValid = false;
          }
        });
        if (isFormatValid) {
          let params = {
            login: this.userForm.login,
            id: this.userForm.id,
          };
          checkValidLogin(params).then((response) => {
            if (response.data == true) {
              this.loginExist = "このログインIDは既に登録されています";
            }
          });
        }
      }
    },
    validateZipcode() {
      this.$refs.zipcodeForm.validate();
      if (this.zipcodeValid) {
        var newVal = this.userForm.zipCdPart1 + this.userForm.zipCdPart2;
        if (this.prevZipcode != newVal) {
          new YubinBangoCore(newVal, (addr) => {
            if (addr.region) {
              this.prefec = addr.region;
              this.address = addr.locality + addr.street;
            }
          });
        }
        this.prevZipcode = newVal;
      }
    },
    cancel() {
      this.$router.push("/admin/users");
    },
  },
  async mounted() {
    this.login_user = JSON.parse(localStorage.getItem("adminUserInfo"));
    if (this.login_user.user_code != this.user_tab.ADMIN) {
      this.$router.push({
        name: "401",
      });
    }
    const navigationBar = this.$parent.$parent.$parent;
    navigationBar.setFooter(['ユーザー一覧', 'ユーザー編集'], '/admin/users', true);
  },
};
</script>
<style lang="scss" scoped>
.default-header {
  .page-main-content {
    .v-main__wrap {
      padding-left: 40px;
      padding-right: 20px;
      padding-bottom: 10px;
    }
  }
}
.text-sub-title {
  font-size: $size-normal;
  color: $color-title;
  margin-top: 5px;
  padding-left: 7px;
}
.btn-text {
  font-size: $size-btn-font;
  font-weight: bold;
}
.btn-margin {
  margin-right: 40px !important;
}
.category-select {
  display: block;
}
.checkbox-margin {
  .v-messages {
    min-height: 0px !important;
  }
}
.btn-area {
  text-align: left;
}

.arrow-icon {
  height: 11px;
}
@media (max-width: 768px) {
  .btn-text {
    width: 130px;
  }
}
/* phone size */
@media screen and (max-width: 763px) {
  .container {
    margin-left: 0px !important;
  }
  .common-title {
    display: none;
  }
  .btn-margin {
    margin: 0 auto !important;
  }
  .display-checkbox {
    margin-left: 8px !important;
  }
  .vip-mobile {
    margin-left: 8px !important;
  }
}

/* ipad size */
@media (min-width: 768px) and (max-width: 1024px) {
  .btn-text {
    width: 160px !important;
  }
}
@media screen and (max-width: 763px) {
  .admin-user-info .container {
    width: 100% !important;
  }
  .btn-text {
    margin-bottom: 40px !important;
  }
}
</style>
<style lang="scss">
.admin-user-info {
  .input-login {
    .theme--light.v-icon {
      color: $admin-primary;
    }
  }
}
.main-title {
  font-size: $size-title;
  color: $admin-color-title;
  font-weight: bold;
}
@media screen and (max-width: $size-mobile) {
  .admin-user-info {
    overflow: hidden;
    .container {
      padding: 0 !important;
    }
  }
  .btn-area {
    text-align: center !important;
  }
}
</style>